export function routes($stateProvider) {
    $stateProvider
        .state('app.elv.agendamentos', {
        url: '/agendamentos',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.elv.agendamentos.list', {
        url: '/?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Agendamento de Inspeções de Elevadores',
        template: require('./directory/directory.view.html'),
        controller: 'DirectorySchedulingElevadoresController',
        controllerAs: 'vm',
        role: 'elvListarAgendamentos',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            },
            state: {
                value: 1,
                dynamic: true
            }
        }
    })
        .state('app.elv.agendamentos.details', {
        url: '/{id}',
        title: 'Detalhes do Técnico',
        template: require('./tecnico/tecnico.view.html'),
        controller: 'TecnicoElevadoresController',
        controllerAs: 'vm',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        },
        role: 'elvListarAgendamentos'
    });
}
routes.$inject = ['$stateProvider'];
